import React from 'react';
import { Helmet } from "react-helmet";

import { decodeHtml } from 'helpers';

const HeadMeta = props => {
    const { page } = props;

    if(!page) return null;

    if(page.yoast) {

        let title = page.yoast.title;
        if(!title && page.title && page.title.rendered) title = page.title.rendered;
        if(!title && page.post_title) title = page.post_title;
        if(!title && page.name) title = page.name; // for terms

        let description = nn(page.yoast.description);

        if(page.type === 'author') {
            title = nn(page.yoast.author_title) ? page.yoast.author_title : page.first_name+' '+page.last_name;
            if(nn(page.yoast.author_desc)) description = page.yoast.author_desc;
        }

        //console.log('Yoast meta', page.yoast);

        return (
            <Helmet>

                <title itemProp="name" lang="nb-NO">{decodeHtml(title)}</title>
                <meta name="description" content={description} />

                <meta property="og:url" content={nn(page.link)} />
                <meta property="og:title" content={nn(page.yoast.og_title)} />
                <meta property="og:description" content={nn(page.yoast.og_desc)} />
                <meta property="og:image" content={nn(page.yoast.og_image)} />

                <meta property="twitter:title" content={nn(page.yoast.twitter_title)} />
                <meta property="twitter:description" content={nn(page.yoast.twitter_desc)} />
                <meta property="twitter:image" content={nn(page.yoast.twitter_image)} />
                <meta name="keywords" content={nn(page.yoast.focuskw)} />
            </Helmet>
        )
    } else {
        console.log('"Yoast" meta not available for this page/post');
        return null;
    }
}

const nn = str => {
    if(!str) return '';
    if(str === 'null') return '';

    return str;
}

export default HeadMeta;


// WEBPACK FOOTER //
// ./src/partials/HeadMeta.js